/**
 * Careers section header — eyebrow, large heading, body copy, and "View Open
 * Roles" CTA. Sits inside the shared `.careers` background wrapper, directly
 * above the `CardStack` stacking cards (`.cards-intro` in the design mock).
 */

import styles from './careers-intro.module.scss';

import type { CareersIntro as CareersIntroContent } from '../content';

export default function CareersIntro({ content }: { content: CareersIntroContent }) {
  return (
    <div className={styles.intro} data-reveal>
      <div className={styles.eyebrow}>{content.eyebrow}</div>
      <h2 className={styles.heading}>{content.heading}</h2>
      <p className={styles.body}>{content.body}</p>
      <a className={styles.cta} href={content.cta.href} target="_blank" rel="noopener noreferrer">
        {content.cta.label}
      </a>
    </div>
  );
}
